// tslint:disable:variable-name
import store from '@/store';


// Helper class for building api route URI's
export default class ApiRoutes {

    private static get BASE_URL() {
        // FIXME: preliminary six of undefined url in socketio and api requests
        // return store.getters['settings/getApiUrl'];
        return 'https://operaguru.cosy.univie.ac.at';
    }

    private static get BASE_API_URL() {
        return this.BASE_URL + '/api/';
    }

    public static get SOCKET_ADDRESS() {
        return this.BASE_URL + ":443";
    }

    public static getPerformancesRequest() {
        return new Request(this.BASE_API_URL + 'performance/projects/');
    }

    public static getProfilesRequest(project_id: number) {
        return new Request(this.BASE_API_URL + `performance/projects/${project_id}/profiles/`);
    }

    // Retrieve all displayitems published so far in the live feed
    public static getLiveFeedRequest(project_id: number, profile_id: number) {
        return new Request(this.BASE_API_URL + `performance/projects/${project_id}/livefeed/${profile_id}/`);
    }

    public static getGlobalHeatmapRequest() {
        return new Request(this.BASE_API_URL + 'statistics/heatmap/all/');
    }

    public static getHostsRequest(host_id: number) {
        return new Request(this.BASE_API_URL + `host/${host_id}`);
    }

    public static getAvailableHostsRequest() {
        return new Request(this.BASE_API_URL + 'host/availableHosts');
    }

    // Try to log in to a certain host
    public static getLoginRequest(pin: number) {

        const request = new Request(
            this.BASE_API_URL + 'host/login', {
                method: 'POST',
                body: pin.toString(),
                headers: {
                    'Content-Type': 'application/json'
                },
            });

        return request;
    }

    public static getSendHeatmapRequest(heatmap: any) {

        const request = new Request(
            this.BASE_API_URL + 'statistics/heatmap/', {
                method: 'POST',
                body: heatmap,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return request;
    }

    public static getSendLogInfoRequest(LogInfo: any) {

        const request = new Request(
            this.BASE_API_URL + 'logerror/saveAll/', {
                method: 'POST',
                body: LogInfo,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return request;
    }

    public static getSendDeviceInfoRequest(DeviceInfo: any) {

        const request = new Request(
            this.BASE_API_URL + 'statistics/device-info/saveOne/', {
                method: 'POST',
                body: DeviceInfo,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return request;
    }

    public static getSendDeviceSettingsRequest(DeviceSettings: any) {

        const request = new Request(
            this.BASE_API_URL + 'statistics/device-settings/saveOne/', {
                method: 'POST',
                body: DeviceSettings,
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return request;
    }
}
